import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast, Toaster } from "sonner";
import ThreeScene from "../components/ThreeScene";
import { PHONE, WHATSAPP_URL, CITY, services } from "../lib/data";

export default function Contact() {
    const [form, setForm] = useState({ name: "", phone: "", service: "", message: "" });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!form.name.trim() || !form.phone.trim()) {
            toast.error("الرجاء إدخال الاسم ورقم الجوال");
            return;
        }
        const text = `السلام عليكم%0A*الاسم:* ${form.name}%0A*الجوال:* ${form.phone}%0A*الخدمة:* ${form.service || "استفسار عام"}%0A*الرسالة:* ${form.message || "-"}`;
        window.open(`https://wa.me/966575640550?text=${text}`, "_blank");
        toast.success("جاري تحويلك للواتساب...");
    };

    return (
        <main data-testid="contact-page">
            <Toaster position="top-center" richColors />
            <section className="relative min-h-[55vh] dark-marble-bg overflow-hidden grain">
                <div className="absolute inset-0 opacity-35">
                    <ThreeScene variant="side" />
                </div>
                <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 pb-16 text-center">
                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                        <div className="eyebrow mb-4">اتصل بنا</div>
                        <h1 className="hero-title text-white mb-4">
                            نحن على <span className="gold-text">مسافة اتصال</span>
                        </h1>
                        <p className="text-white/70 max-w-xl mx-auto">معاينة مجانية وعرض سعر خلال ساعات</p>
                    </motion.div>
                </div>
            </section>

            <section className="marble-bg py-20">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <div className="grid lg:grid-cols-5 gap-8">
                        {/* INFO */}
                        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="lg:col-span-2 space-y-4">
                            <a href={`tel:${PHONE}`} className="block group" data-testid="contact-phone-card">
                                <div className="glass rounded-2xl p-6 flex items-center gap-5 tilt-hover">
                                    <div className="icon-orbit w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg, #e8c86a, #8a6d2b)" }}>
                                        <i className="fa-solid fa-phone text-[#0a0a0a] text-lg" />
                                    </div>
                                    <div className="text-right flex-1">
                                        <div className="text-xs text-[#0a0a0a]/60 mb-1">اتصل مباشرة</div>
                                        <div className="font-display text-2xl text-[#0a0a0a]" dir="ltr">{PHONE}</div>
                                    </div>
                                </div>
                            </a>

                            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="block group" data-testid="contact-whatsapp-card">
                                <div className="glass rounded-2xl p-6 flex items-center gap-5 tilt-hover">
                                    <div className="icon-orbit w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg, #25D366, #128C7E)" }}>
                                        <i className="fa-brands fa-whatsapp text-white text-2xl" />
                                    </div>
                                    <div className="text-right flex-1">
                                        <div className="text-xs text-[#0a0a0a]/60 mb-1">واتساب فوري</div>
                                        <div className="font-display text-2xl text-[#0a0a0a]">راسلنا الآن</div>
                                    </div>
                                </div>
                            </a>

                            <div className="glass rounded-2xl p-6 flex items-center gap-5">
                                <div className="icon-orbit w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg, #e8c86a, #8a6d2b)" }}>
                                    <i className="fa-solid fa-location-dot text-[#0a0a0a] text-lg" />
                                </div>
                                <div className="text-right flex-1">
                                    <div className="text-xs text-[#0a0a0a]/60 mb-1">الموقع</div>
                                    <div className="font-display text-lg text-[#0a0a0a]">{CITY}، عسير - السعودية</div>
                                </div>
                            </div>

                            <div className="glass rounded-2xl p-6 flex items-center gap-5">
                                <div className="icon-orbit w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg, #e8c86a, #8a6d2b)" }}>
                                    <i className="fa-solid fa-clock text-[#0a0a0a] text-lg" />
                                </div>
                                <div className="text-right flex-1">
                                    <div className="text-xs text-[#0a0a0a]/60 mb-1">ساعات العمل</div>
                                    <div className="font-display text-lg text-[#0a0a0a]">24 ساعة / 7 أيام</div>
                                </div>
                            </div>
                        </motion.div>

                        {/* FORM */}
                        <motion.form
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7 }}
                            onSubmit={handleSubmit}
                            className="lg:col-span-3 bg-white rounded-3xl p-8 md:p-10 gold-ring"
                            data-testid="contact-form"
                        >
                            <h2 className="font-display text-3xl text-[#0a0a0a] mb-2">اطلب معاينة مجانية</h2>
                            <p className="text-[#0a0a0a]/60 text-sm mb-8">املأ النموذج وسنتواصل معك خلال 30 دقيقة</p>

                            <div className="grid md:grid-cols-2 gap-5 mb-5">
                                <div>
                                    <label className="block text-sm text-[#0a0a0a]/75 mb-2 font-semibold">الاسم الكامل *</label>
                                    <input
                                        type="text"
                                        value={form.name}
                                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                                        placeholder="أدخل اسمك"
                                        className="w-full px-4 py-3 rounded-xl border border-[rgba(201,169,97,0.3)] bg-[#fdfcf7] focus:outline-none focus:border-[#c9a961] focus:ring-2 focus:ring-[rgba(201,169,97,0.15)] transition text-right"
                                        data-testid="input-name"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm text-[#0a0a0a]/75 mb-2 font-semibold">رقم الجوال *</label>
                                    <input
                                        type="tel"
                                        value={form.phone}
                                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                                        placeholder="05xxxxxxxx"
                                        className="w-full px-4 py-3 rounded-xl border border-[rgba(201,169,97,0.3)] bg-[#fdfcf7] focus:outline-none focus:border-[#c9a961] focus:ring-2 focus:ring-[rgba(201,169,97,0.15)] transition text-right"
                                        dir="ltr"
                                        data-testid="input-phone"
                                    />
                                </div>
                            </div>

                            <div className="mb-5">
                                <label className="block text-sm text-[#0a0a0a]/75 mb-2 font-semibold">الخدمة المطلوبة</label>
                                <select
                                    value={form.service}
                                    onChange={(e) => setForm({ ...form, service: e.target.value })}
                                    className="w-full px-4 py-3 rounded-xl border border-[rgba(201,169,97,0.3)] bg-[#fdfcf7] focus:outline-none focus:border-[#c9a961] focus:ring-2 focus:ring-[rgba(201,169,97,0.15)] transition text-right"
                                    data-testid="input-service"
                                >
                                    <option value="">اختر الخدمة</option>
                                    {services.map((s) => (
                                        <option key={s.id} value={s.title}>{s.title}</option>
                                    ))}
                                    <option value="استفسار عام">استفسار عام</option>
                                </select>
                            </div>

                            <div className="mb-8">
                                <label className="block text-sm text-[#0a0a0a]/75 mb-2 font-semibold">تفاصيل إضافية</label>
                                <textarea
                                    value={form.message}
                                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                                    placeholder="اكتب تفاصيل مساحة العمل، نوع الرخام، أو أي ملاحظات..."
                                    rows="5"
                                    className="w-full px-4 py-3 rounded-xl border border-[rgba(201,169,97,0.3)] bg-[#fdfcf7] focus:outline-none focus:border-[#c9a961] focus:ring-2 focus:ring-[rgba(201,169,97,0.15)] transition text-right resize-none"
                                    data-testid="input-message"
                                />
                            </div>

                            <button type="submit" className="gold-btn w-full text-center" data-testid="submit-form-btn">
                                <i className="fa-brands fa-whatsapp ml-2" />إرسال عبر واتساب
                            </button>

                            <p className="text-center text-[#0a0a0a]/50 text-xs mt-4">
                                سيتم تحويلك مباشرة للواتساب مع تفاصيل طلبك جاهزة
                            </p>
                        </motion.form>
                    </div>
                </div>
            </section>
        </main>
    );
}
